var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('compare-toggle-button',{attrs:{"product-id":_vm.productId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var compare = ref.compare;
return [_c('div',{staticClass:"icon-button",attrs:{"title":_vm._('Удалить из избранного')},on:{"click":function($event){$event.preventDefault();return compare.apply(null, arguments)}}},[_c('i',{staticClass:"icon-trash"})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }